/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 16:57:55
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-11 14:40:51
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 查询自定义数据结果
export const fillList = params =>
  request(BASE_URL + '/govactivityData/fillList', { params })
// 修改丽企大讲堂自定义数据
export const updateFillData = data =>
  request.post(BASE_URL + '/govactivityData/updateFillData', data)
// 自定义数据启用状态查询
export const fillStatusList = params =>
  request(BASE_URL + '/govactivityData/fillStatusList', { params })
// 更改启用状态
export const changeFillStatus = params =>
  request(BASE_URL + '/govactivityData/changeFillStatus', { params })
// 惠企政策自定义数据
export const updateEntPolicy = data =>
  request.post(BASE_URL + '/govactivityData/updateEntPolicy', data)
// 查询驻企导入历史记录
export const getEntAppealImportHistoryList = params =>
  request(BASE_URL + '/appeal/getEntAppealImportHistoryList', { params })
// 查询驻企导入历史记录
export const getEntAppealImportFailList = params =>
  request(BASE_URL + '/appeal/getEntAppealImportFailList', { params })
// 下载模板
// 驻企走访导入
export const importEntAppeal =
  process.env.VUE_APP_BASE_API + BASE_URL + '/enterprise/importEntAppeal'
export const downLoadImportAppealTemplate = (params, filename) => {
  return request.downLoad(
    BASE_URL + '/appeal/downLoadImportAppealTemplate',
    params,
    filename
  )
}

// 五企标签列表
export const addEntLabelFill = data =>
  request.post(BASE_URL + '/govactivityData/addEntLabelFill', data)
// 五企标签列表
export const getEntLabelFillList = params =>
  request(BASE_URL + '/govactivityData/entLabelFillList', { params })
// 新增修改五企培育标签
export const updateEntLabelFill = params =>
  request.post(BASE_URL + '/govactivityData/updateEntLabelFill', params)

